import { BaseText, Button, theme } from 'aimo-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePermitStore } from 'stores/permitStore';
import { StyledWrapper } from 'styles/ContainerStyles';
import { Maybe, ParkingSpace } from 'types/generatedSchemaTypes';
import useUserPermitById from 'hooks/useUserPermitById';
import { useUiStore } from 'stores/uiStore';

const PermitOrderLineModalContent: React.FC = () => {
  const { t } = useTranslation();
  const permitId = usePermitStore((state) => state.selectedPermitId);
  const setSelectedPermitId = usePermitStore(
    (state) => state.setSelectedPermitId
  );
  const items = useUserPermitById(permitId)?.['resolvedParkingSpaces'] ?? [];

  const extractName = (item: Maybe<ParkingSpace>): string => {
    return (item as ParkingSpace)?.name ?? '';
  };

  const modalContext = items
    .map(extractName)
    .filter((name): name is string => Boolean(name))
    .sort((a, b) => a.localeCompare(b))
    .join(', ')
    .concat('.');

  return (
    <>
      <StyledWrapper
        center={true}
        mb={50}
        testID={'permit-parking-space-modal'}>
        <BaseText color={theme.colors.gray300}>{modalContext}</BaseText>
      </StyledWrapper>
      <StyledWrapper>
        <Button
          size="l"
          onPress={() => {
            setSelectedPermitId(undefined);
            useUiStore.getState().setSheetModal('');
          }}
          text={t('button.close')}
          testID="close-button"
        />
      </StyledWrapper>
    </>
  );
};

export default PermitOrderLineModalContent;
